import type { EstadoProyecto } from "../api/types";
import { CATEGORIA_ESTADO, ETIQUETAS_ESTADO } from "../utils/estados";
import estilos from "./BadgeEstado.module.css";

interface Props {
  estado: EstadoProyecto;
}

export function BadgeEstado({ estado }: Props): JSX.Element {
  const categoria = CATEGORIA_ESTADO[estado] ?? "neutral";
  const etiqueta = ETIQUETAS_ESTADO[estado] ?? estado;
  return (
    <span className={`${estilos.badge} ${estilos[categoria]}`} role="status">
      {etiqueta}
    </span>
  );
}
